import { Link } from 'react-router-dom';

interface LogoProps {
  subtitle?: string;
  size?: 'sm' | 'md' | 'lg';
  showSubtitle?: boolean;
  variant?: 'light' | 'dark';
}

const Logo = ({ subtitle = 'Service Discovery', size = 'md', showSubtitle = true, variant = 'light' }: LogoProps) => {
  const sizes = {
    sm: { icon: 'w-8 h-8', text: 'text-lg', subtitle: 'text-[8px]' },
    md: { icon: 'w-10 h-10', text: 'text-xl', subtitle: 'text-[9px]' },
    lg: { icon: 'w-12 h-12', text: 'text-2xl', subtitle: 'text-[10px]' },
  };

  const isDark = variant === 'dark';

  return (
    <Link to="/" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
      <div className={`${sizes[size].icon} flex items-center justify-center relative`}>
        <svg className="w-full h-full" viewBox="0 0 100 100">
          <circle cx="50" cy="25" fill="#adff2f" r="12" />
          <circle cx="30" cy="55" fill="#e6fbff" r="12" />
          <circle cx="70" cy="55" fill="#fff0f6" r="12" />
        </svg>
      </div>
      <div className="flex flex-col">
        <span className={`${sizes[size].text} font-extrabold tracking-tight ${isDark ? 'text-white' : 'text-brand-dark'}`}>
          PROFESTIVAL<span className="text-primary">.CZ</span>
        </span>
        {showSubtitle && (
          <span className={`${sizes[size].subtitle} uppercase tracking-[0.2em] ${isDark ? 'text-white/70' : 'text-slate-500'} font-bold`}>
            {subtitle}
          </span>
        )}
      </div>
    </Link>
  );
};

export default Logo;
